<template>
    <CCard >      
      <CCardBody>       
        <CRow>      
          
          <CCol sm="12" lg="12" >                     
            <div style="border: 1px solid rgb(206, 210, 216);margin-top: 0px;padding-bottom: 5px;padding-top: 5px;border-bottom-width: 0px;">
              <div style="display: inline-block; padding: 10px;">主旨:</div>
              <div style="display: inline-block; width: 70%;"><ejs-textbox id="ProductName" floatLabelType="Auto"  placeholder="" v-model="ProductName" ></ejs-textbox></div>   
            
              <br/>
              <div style="display: inline-block; padding: 10px;">寄件給:</div>
              <div style="display: inline-block; padding: 10px;">
                <ejs-radiobutton label="內部使用者" name="ContactType" :value=0 :disabled="Seletdisable" :checked="selectedContactType === 0" @change="onIsContactTypeChange"></ejs-radiobutton>&nbsp; 
                <ejs-radiobutton label="供應商" name="ContactType" :value=1 :disabled="Seletdisable" :checked="selectedContactType === 1" @change="onIsContactTypeChange"></ejs-radiobutton>
              </div>
              <div style="display: inline-block; padding: 10px;">收件者:</div>
              <div style="display: inline-block; width: 200px;">
                <ejs-dropdowntree id='dropdowntree' ref="ddtreeObj"  :value="dropdowntreeValues" :showSelectAll='true' @change="onSelectionChange" :treeSettings='treeSettings' :fields='fields' :showCheckBox='true' mode= 'Custom' :placeholder='"請選擇發送對象"'  ></ejs-dropdowntree>
              </div> 
              <div style="display: inline-block; padding: 10px;">重要:</div>
              <div style="display: inline-block; padding: 10px;">
                <ejs-radiobutton label="是" name="cht" :value=true :checked="e_isimporcht == true" @change="onIsImportChange"></ejs-radiobutton>&nbsp; 
                <ejs-radiobutton label="否" name="cht" :value=false :checked="e_isimporcht == false" @change="onIsImportChange"></ejs-radiobutton>
              </div>
              <div style="display: inline-block; padding: 10px;">發送起訖日:</div>
             
              <div style="display: inline-block; padding: 10px;">              
                <ejs-daterangepicker width="300px" id="datetimepicker" :placeholder="waterMarkText" v-model="SendTime"  :format="selectedFormat"></ejs-daterangepicker>
              </div>
              <div style="display: inline-block; padding: 10px;">              
                <ejs-button :isPrimary="true" v-on:click.native='postMsg'>送出</ejs-button>
                <!-- <ejs-button :isPrimary="true" v-on:click.native='postMsg'>修改</ejs-button> -->
              </div>              
            </div>           
          </CCol>         
          <CCol sm="12" lg="12"> 
            <!-- 使用 quill-editor 组件 -->
            <quill-editor v-model="htmlContent" :options="editorOptions" style="height:400px; margin-bottom: 40px;"></quill-editor>
            <!--<div>
                <h3>编辑器内容:</h3>
                {{ htmlContent }}
                <div class="form-control" 
                    type="text" id="view-container-wiki" 
                    readonly 
                    v-html="htmlContent">
                </div>
                
            </div> -->
          </CCol>
        </CRow>
        <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast> 
      </CCardBody>   
    </CCard>
  </template>
  <script>
  // npm install vue-quill-editor --save


  import Vue from "vue";
  import { L10n, loadCldr , setCulture} from '@syncfusion/ej2-base';
  import { DropDownTreeComponent } from "@syncfusion/ej2-vue-dropdowns";
  import { TextBoxPlugin, NumericTextBoxPlugin  } from '@syncfusion/ej2-vue-inputs';  
  import { ButtonComponent, RadioButtonComponent } from "@syncfusion/ej2-vue-buttons";
  import { quillEditor } from 'vue-quill-editor';
  import { ToastComponent, } from "@syncfusion/ej2-vue-notifications";
  import { DateRangePickerComponent } from '@syncfusion/ej2-vue-calendars';
  import frNumberData from '@syncfusion/ej2-cldr-data/main/zh-Hans-HK/numbers.json';
  import frtimeZoneData from '@syncfusion/ej2-cldr-data/main/zh-Hans-HK/timeZoneNames.json';
  import frGregorian from '@syncfusion/ej2-cldr-data/main/zh-Hans-HK/ca-gregorian.json';
  import frNumberingSystem from '@syncfusion/ej2-cldr-data/supplemental/numberingSystems.json';
  import Loading from 'vue-loading-overlay';
  import zhtwLocalization  from '../language/language.json';
  import 'quill/dist/quill.snow.css';  // Quill 样式
  


  L10n.load(zhtwLocalization);
  Vue.use(TextBoxPlugin);
  Vue.use(NumericTextBoxPlugin );
  Vue.use(Loading);
  loadCldr(frNumberData, frtimeZoneData, frGregorian, frNumberingSystem);
  setCulture('zh-Hans-HK');


  export default {
  name: 'EditorComponent',
  components: {
    "ejs-daterangepicker": DateRangePickerComponent,  
    quillEditor,
    'ejs-button': ButtonComponent,
    'ejs-toast': ToastComponent,
    'ejs-radiobutton': RadioButtonComponent,
    'ejs-dropdowntree': DropDownTreeComponent
    
  },
  data: function() {
    return {  
      Seletdisable:false,
      selectedContactType:0,
      position: { X: 'Right', Y: "Bottom" }, 
      SendTime:[new Date(), new Date(new Date().setMonth(new Date().getMonth() + 1))  ],
      SendMsgtype:0,
      e_msgId:undefined,
      e_isimporcht:true,
      dropdowntreeValues:[],
      chtImport:false,
      editorOptions:null,
      waterMarkText:null,
      ProductName:null,      
        htmlContent: '',  // 存储编辑器内容        
        selectedFormat: 'yyyy-MM-dd hh:mm a',
        data:[],
        fields: { dataSource: [], value: 'id', text: 'name', parentValue: 'pid', hasChildren: 'hasChild' },
            height: '200px',
            waterMark: 'Select items',
            treeSettings: { autoCheck: true },
            customTemplate: '${value.length} item(s) selected'
      };
  },
  created() {

    const msgID = this.$route.query.msgID;
    this.e_msgId =msgID;
    if(msgID == "add"){
      this.geteEployee();
      this.Seletdisable=false;
      return;
    }
    this.Seletdisable=true;
    switch (this.$route.query.usercategory) {
        case '0':
           this.selectedContactType=0;
          this.geteEployee();
          break;
        case '1':
          this.selectedContactType=1;
          this.getSCM();
          break;
        default:
          this.selectedContactType=0;
          console.log('未知按鈕');
      }
      this.$nextTick(() => {
         this.getMsg();
      });
   

  },
  methods: {    
    onIsContactTypeChange:function(args){
      this.SendMsgtype=Number(args.value);
      switch (args.value) {
        case '0':
          this.geteEployee();
          break;
        case '1' :
          //  this.fields= { dataSource: Dropdowndata, value: 'id', text: 'name', parentValue: 'pid', hasChildren: 'hasChild' };
          this.getSCM();
          break;
        default:
          this.geteEployee();
          console.warn('未知的 contact type:', args.value);
      }
    },
    onIsImportChange(args){
      switch (args.value) {
        case '0':
          this.e_isimporcht=true;
          break;
        case '1' :
            this.e_isimporcht=false;
          break;
        default:
          this.e_isimporcht=false;
      }
    },
    onSelectionChange(e) {
      this.dropdowntreeValues = e.value;
      // console.log(this.dropdowntreeValues);
    },
    onSend(){
      // console.log(this.htmlContent);
    },
    //api
    getSCM: function () {  
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/SCM/CustomerMsg`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.fields= { dataSource: response.data.datas, value: 'id', text: 'name', parentValue: 'pid', hasChildren: 'hasChild' };
        // console.log("SCM",response.data.datas);
      })
      .catch((error) => { 
        this.showError(error, true) }
      )             
    },
    geteEployee: function () {  
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Account/Message/User`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.fields= { dataSource: response.data.datas, value: 'id', text: 'name', parentValue: 'pid', hasChildren: 'hasChild' };
        console.log("Eployee",response.data.datas);
      })
      .catch((error) => { 
        this.showError(error, true) }
      )             
    },
    getMsg: function () {  
      // console.log(this.e_msgId);
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Message/Msg?msgid=${this.e_msgId}&&roletype=${this.selectedContactType}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.ProductName = response.data.datas.title;
        this.htmlContent = response.data.datas.message;
        this.e_isimporcht = response.data.datas.import;
        this.dropdowntreeValues = response.data.datas.receive.split(",");
        console.log("user:",response.data.datas)
      })
      .catch((error) => { 
        this.showError(error, true) 
      })             
    },
    postMsg: function () {  
      if(this.SendTime == null){
        this.$refs.toastRef.show( { title: '錯誤!', content: "請選擇發送起訖日", cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); 
        return;
      }
      console.log("SendMsgtype:",this.SendMsgtype)
      this.axios({
          method: this.e_msgId === "add" ? 'post' : 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url:'/Message',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data:{
            MsgID:this.e_msgId,
            title:this.ProductName,
            content:this.htmlContent,
            roletype:this.SendMsgtype,
            user:this.dropdowntreeValues,
            is_import:this.e_isimporcht,
            begindate: this.formatDate(this.SendTime[0]),
            enddate: this.formatDate(this.SendTime[1]),
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        

        this.$refs.toastRef.show( { title: '成功新增訊息!', content: response.data.msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' }); 
        this.$router.push(`/system/message?toastf=${response.data.msg}`);
        return;
        // console.log("data",response.data.datas);
      })
      .catch((error) => { 
        console.log("error",error)
        // this.showError(error, true) 
      })             
    },
    
    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hour = String(d.getHours()).padStart(2, '0');
      const minute = String(d.getMinutes()).padStart(2, '0');
      const second = String(d.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
  },
  provide: {
  },

  mounted() {
    
  },
  beforeUpdate() {
    
  },
  beforeDestroy() {
   
  }  
  }
  </script>
  <style lang="scss" src="../../scss/base.scss"></style>